<template>
  <span
    class="s-label"
    v-html="label"
  ></span>
</template>

<script>
export default {
  name: 'SLabel',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.s-label {
  display: inline-flex;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6em;
  color: #FFF;
  border-radius: 4px;
  background-color: $primary;

  &:not(:last-child) {
    margin-right: 8px;
  }
}
</style>